
export const regex = {
	// eslint-disable-next-line no-useless-escape
	email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/,
	phone: /^[0-9]{1,15}$/
};